import { ExpiredLink as StyledExpiredLink } from './ExpiredLink.styles.js';

import AmigoLogo from '../../assets/images/amigo-name-logo.svg';
import ExpiredLinWarningIcon from '../../assets/images/expired-link-warning-icon.svg';

import './index.scss';

const ExpiredLink = () => (
	<StyledExpiredLink className='doca h-100 ds-flex ds-flex__justify--center ds-flex__align--center'>
		<StyledExpiredLink.InfoContainer>
			<StyledExpiredLink.InfoTitle>Este link expirou</StyledExpiredLink.InfoTitle>

			<div className="mobile-image">
				<StyledExpiredLink.ExpiredLinWarningIcon  src={ExpiredLinWarningIcon} />
			</div>

			<StyledExpiredLink.InfoText>
				Pode ser que este documento já tenha sido assinado por você ou que o prazo de 30 dias para assinatura do documento tenha expirado.
				<br/>
				<br/>
				Se precisar, entre em contato com a clínica e solicite um novo envio do documento.
			</StyledExpiredLink.InfoText>
			<StyledExpiredLink.AmigoLogo src={AmigoLogo} />

		</StyledExpiredLink.InfoContainer>
		<StyledExpiredLink.ExpiredLinWarningIcon className="desktop-image" src={ExpiredLinWarningIcon} />
	</StyledExpiredLink>
);

export default ExpiredLink;
